<template>
  <div class="goover">
    <Header></Header>
    <div class="contain_main">
      <div class="search">
        <div class="item">
          <!-- <span>选择考试:</span>
          <Select v-model="model1" style="width:2.5rem">
            <Option value="1">新员工入职考试（ID:43566787）</Option>
            <Option value="2">新员工入职考试2（ID:43566787）</Option>
            <Option value="3">新员工入职考试3（ID:43566787）</Option>
          </Select> -->
        </div>
        <div class="item">
          <div class="button" @click="$router.go(-1)">返回</div>
        </div>
      </div>
      <div class="main">
          <div class="title">
              试题
          </div>
          <div class="item"  v-for="(item,index) in list" :key="'itemed'+index">
              <Question :order="index+1" :total="list.length" :data="item"></Question>
              <div class="bottom">
                  <div class="button" @click="questshow(item)" style="width:1.3rem">查看答案详情</div>
                  <div class="button" @click="scanshow(item)" style="width:1.1rem;">阅卷</div>
              </div>
          </div>
      </div>
    </div>
    <div>
        <scansolution @close="close" :examid="$route.query.id" :message="message" v-if="scansolutionshow"></scansolution>
        <questlist @close="close" :data="data"  :examid="$route.query.id" v-if="questlistshow"></questlist>
    </div>
  </div>
</template>
<script>
import Header from "../../components/header";
import Question from '../../components/question'
import scansolution from '../../components/toast/scansolution'
import questlist from '../../components/toast/questlists'
import {ExamScore_index,ExamScore_questionCount} from '../../assets/js/api.js'
export default {
  data() {
    return {
        model1:null,
        scansolutionshow:false,
        questlistshow:false,
        list:[],
        listyuan:[],
        id:null,
        // 以下数据用于阅卷
        data:null,
        message:null
    };
  },
  mounted(){
    if(this.$route.query.id){
      this.id = this.$route.query.id
    }else{
      this.$router.go(-1)
      return 
    }
    this.getlist()
  },
  components: {
    Header,
    Question,
    scansolution,
    questlist
  },
  methods:{
    close(){
      this.scansolutionshow=false
      this.questlistshow=false
      this.getlist()
    },
    getlist(){
      ExamScore_index({examid:this.id}).then(
        res=>{
          if(res.data.code==200){
            this.listyuan = res.data.data.epquestions
            this.getinfo()
          }
        }
      )
    },
    getinfo(){
      ExamScore_questionCount({examid:this.id}).then(
        res=>{
          if(res.data.code==200){
            var map = new Map()
            res.data.data.forEach(item=>{
              map.set(item.questionid,[item.total,Number(item.count)])
            })
            this.list=this.listyuan.map(item=>{
             if(map.get(item.questionid-0)){
               item.total = map.get(item.questionid-0)[0]
               item.dcount = map.get(item.questionid-0)[1]
              //  item.less = map.get(item.questionid-0)[2]
             }else{
               return false
             }
             return item 
            }).filter(item=>{return item})
          }
        }
      )
    },
    scanshow(data){
      // if(data.total==data.less){
      //   this.$Notice.warning({ title: "信息提示", desc:"正在考试，无法阅卷" });
      //   return 
      // }
      this.message=data
      this.scansolutionshow=true
    },
    questshow(data){
      this.data= data
      this.questlistshow=true
    }
  }
};
</script>
<style lang="css" scoped>
.search {
  margin: 0.4rem 0;
  display: flex;
  color: #575e6b;
  justify-content: space-between;
}
.search .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
.title{
    margin:0.3rem 0;
    font-size: 0.24rem;
    color: #464646;
    text-align: left;
}
.bottom{
    display: flex;
    justify-content: flex-start;
    margin: 0.27rem 0;
    padding-left: 0.65rem;
}
.bottom .button{
    height: 0.34rem;
    line-height: 0.34rem;
    margin: 0 0.1rem;
    text-align: center;
    color: #ff064e;
    background: #ffd6de;
}
</style>


// WEBPACK FOOTER //
// src/pages/namnege/gooverpaper.vue